import $ from 'jquery';

$(function () {
    const $app = $('#eos-app');
    if (!$app.length) return;

    const verdictBondsTitle = $app.data('eos-verdict-bonds-title') || 'Інвестувати в ОВДП значно вигідніше!';
    const verdictBondsDescTemplate = $app.data('eos-verdict-bonds-desc') || 'При ставці іпотеки {0}% та дохідності ОВДП {1}% ви заробляєте чистий спред +{2}% річних. Фінансова перевага складає {3} чистого прибутку!';
    const verdictPayoffTitle = $app.data('eos-verdict-payoff-title') || 'Дострокове погашення вигідніше!';
    const verdictPayoffDesc = $app.data('eos-verdict-payoff-desc') || 'Ставка за кредитом дорівнює або вища за ставку облігацій. У цьому разі найвигідніше швидше позбутися боргу перед банком.';
    const beNever = $app.data('eos-breakeven-never') || 'Після терміну';
    const unitYears = $app.data('unit-years') || 'років';
    const unitMonths = $app.data('unit-months') || 'міс';
    const tableYearCellFormat = $app.data('eos-table-year-cell') || '{0} р.';

    const textMoreCurrencies = $app.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $app.data('text-more-short') || 'Ще';

    // Currency configs
    const currencyConfigs = {
        UAH: { symbol: '₴', rate: 1.0, loanMin: 200000, loanMax: 6000000, loanStep: 50000, extraMin: 1000, extraMax: 100000, extraStep: 1000 },
        USD: { symbol: '$', rate: 41.5, loanMin: 5000, loanMax: 150000, loanStep: 2500, extraMin: 50, extraMax: 5000, extraStep: 50 },
        EUR: { symbol: '€', rate: 45.0, loanMin: 5000, loanMax: 140000, loanStep: 2500, extraMin: 50, extraMax: 4500, extraStep: 50 },
        PLN: { symbol: 'zł', rate: 10.5, loanMin: 20000, loanMax: 600000, loanStep: 10000, extraMin: 200, extraMax: 20000, extraStep: 200 },
        GBP: { symbol: '£', rate: 53.0, loanMin: 4000, loanMax: 120000, loanStep: 2000, extraMin: 40, extraMax: 4000, extraStep: 40 },
        CHF: { symbol: 'Fr.', rate: 48.0, loanMin: 5000, loanMax: 140000, loanStep: 2500, extraMin: 50, extraMax: 5000, extraStep: 50 },
        CAD: { symbol: 'C$', rate: 30.0, loanMin: 7000, loanMax: 200000, loanStep: 3000, extraMin: 70, extraMax: 7000, extraStep: 50 },
        CZK: { symbol: 'Kč', rate: 1.80, loanMin: 120000, loanMax: 3500000, loanStep: 50000, extraMin: 1000, extraMax: 60000, extraStep: 500 }
    };

    let activeCurrency = $app.data('currency') || 'UAH';
    if (!currencyConfigs[activeCurrency]) {
        activeCurrency = 'UAH';
    }

    // Base Presets in UAH
    const presetsUah = {
        preferential: { loanAmount: 2000000, loanTermYears: 20, mortgageRate: 3.0, extraPayment: 15000, bondsYield: 15.0 },
        general: { loanAmount: 1800000, loanTermYears: 20, mortgageRate: 7.0, extraPayment: 12000, bondsYield: 15.0 },
        compact: { loanAmount: 1200000, loanTermYears: 15, mortgageRate: 7.0, extraPayment: 10000, bondsYield: 15.0 },
        commercial: { loanAmount: 1500000, loanTermYears: 15, mortgageRate: 15.0, extraPayment: 10000, bondsYield: 15.0 }
    };

    let activePreset = 'preferential';

    function getPresetForCurrency(pKey, curr) {
        const p = presetsUah[pKey] || presetsUah.preferential;
        const rate = currencyConfigs[curr].rate;
        return {
            loanAmount: Math.round(p.loanAmount / rate),
            loanTermYears: p.loanTermYears,
            mortgageRate: p.mortgageRate,
            extraPayment: Math.round(p.extraPayment / rate),
            bondsYield: p.bondsYield
        };
    }

    // State
    const initPreset = getPresetForCurrency(activePreset, activeCurrency);
    const state = { ...initPreset };

    function formatMoney(num) {
        if (isNaN(num) || !isFinite(num)) num = 0;
        const cfg = currencyConfigs[activeCurrency];
        return `${Math.round(num).toLocaleString()} ${cfg.symbol}`;
    }

    function calculate() {
        const principal = state.loanAmount;
        const totalMonths = state.loanTermYears * 12;
        const r_m = (state.mortgageRate / 100) / 12;
        const r_b = (state.bondsYield / 100) / 12;

        // Base Annuity Payment
        let basePayment = 0;
        if (r_m === 0) {
            basePayment = principal / totalMonths;
        } else {
            basePayment = principal * (r_m * Math.pow(1 + r_m, totalMonths)) / (Math.pow(1 + r_m, totalMonths) - 1);
        }

        // --- Simulation A: Early Payoff ---
        let balanceA = principal;
        let totalInterestA = 0;
        let monthsToPayoffA = 0;
        const monthlyBudgetA = basePayment + state.extraPayment;

        for (let m = 1; m <= totalMonths; m++) {
            if (balanceA > 0) {
                const interest = balanceA * r_m;
                totalInterestA += interest;
                const principalPart = Math.min(balanceA, monthlyBudgetA - interest);
                balanceA -= principalPart;
                if (balanceA <= 0) {
                    monthsToPayoffA = m;
                    balanceA = 0;
                }
            }
        }
        if (monthsToPayoffA === 0) monthsToPayoffA = totalMonths;

        // After loan is paid off in month monthsToPayoffA, money accumulates in bonds until totalMonths
        let capitalAtFinishA = 0;
        for (let m = monthsToPayoffA + 1; m <= totalMonths; m++) {
            capitalAtFinishA = (capitalAtFinishA + monthlyBudgetA) * (1 + r_b);
        }

        // Normal base interest if no prepayment
        let normalInterest = 0;
        let tempBal = principal;
        for (let m = 1; m <= totalMonths; m++) {
            const interest = tempBal * r_m;
            normalInterest += interest;
            const principalPart = basePayment - interest;
            tempBal -= principalPart;
        }
        const interestSavedA = Math.max(0, normalInterest - totalInterestA);

        // --- Simulation B: Bonds Arbitrage ---
        let portfolioB = 0;
        let breakevenMonth = null;
        const timeline = [];

        let currentLoanBalanceB = principal;

        for (let m = 1; m <= totalMonths; m++) {
            // Mortgage continues regular schedule
            const loanInterest = currentLoanBalanceB * r_m;
            const loanPrincipal = basePayment - loanInterest;
            currentLoanBalanceB = Math.max(0, currentLoanBalanceB - loanPrincipal);

            // Bonds accumulate extra payment with monthly compounding
            portfolioB = (portfolioB + state.extraPayment) * (1 + r_b);
            const monthlyCoupon = portfolioB * r_b;

            if (!breakevenMonth && monthlyCoupon >= basePayment) {
                breakevenMonth = m;
            }

            // Capture yearly milestones
            if (m % 12 === 0 || m === totalMonths) {
                const yearNum = Math.round(m / 12);
                timeline.push({
                    year: yearNum,
                    loanBalance: currentLoanBalanceB,
                    bondPortfolio: portfolioB,
                    annualCoupons: portfolioB * (state.bondsYield / 100),
                    coverageRatio: basePayment > 0 ? (monthlyCoupon / basePayment) * 100 : 100
                });
            }
        }

        const netArbitrageAdvantage = portfolioB - capitalAtFinishA;
        const isBondsWinning = netArbitrageAdvantage > 0;

        return {
            basePayment,
            monthsToPayoffA,
            totalInterestA,
            interestSavedA,
            capitalAtFinishA,
            portfolioB,
            finalMonthlyCoupon: portfolioB * r_b,
            breakevenMonth,
            netArbitrageAdvantage,
            isBondsWinning,
            timeline
        };
    }

    function render() {
        const res = calculate();

        // Update KPIs
        $('#eos-kpi-payment').text(formatMoney(res.basePayment));
        $('#eos-kpi-arbitrage').text(formatMoney(Math.abs(res.netArbitrageAdvantage)));
        $('#eos-kpi-portfolio').text(formatMoney(res.portfolioB));

        if (res.breakevenMonth) {
            const beYears = (res.breakevenMonth / 12).toFixed(1);
            $('#eos-kpi-breakeven').text(`${beYears} ${unitYears} (${res.breakevenMonth} ${unitMonths})`);
        } else {
            $('#eos-kpi-breakeven').text(beNever);
        }

        // Verdict Banner
        const $verdictCard = $('#eos-verdict-card');
        const $verdictTitle = $('#eos-verdict-title');
        const $verdictDesc = $('#eos-verdict-desc');

        if (res.isBondsWinning) {
            $verdictCard.removeClass('border-warning border-danger bg-warning-subtle').addClass('border-success bg-success bg-opacity-10');
            $verdictTitle.removeClass('text-warning text-danger').addClass('text-success').html(`<i class="bx bx-check-circle me-1"></i> ${verdictBondsTitle}`);
            let descFormatted = verdictBondsDescTemplate
        .replace('{0}', `<strong>${state.mortgageRate}</strong>`)
        .replace('{1}', `<strong>${state.bondsYield}</strong>`)
        .replace('{2}', `<strong>${(state.bondsYield - state.mortgageRate).toFixed(1)}</strong>`)
        .replace('{3}', `<strong>${formatMoney(res.netArbitrageAdvantage)}</strong>`);
    $verdictDesc.html(descFormatted);
        } else {
            $verdictCard.removeClass('border-success bg-success-subtle').addClass('border-warning bg-warning bg-opacity-10');
            $verdictTitle.removeClass('text-success text-danger').addClass('text-warning').html(`<i class="bx bx-error-circle me-1"></i> ${verdictPayoffTitle}`);
            $verdictDesc.text(verdictPayoffDesc);
        }

        // Strategy A Card
        const payoffYearsA = (res.monthsToPayoffA / 12).toFixed(1);
        $('#eos-strat-a-time-val').text(`${payoffYearsA} ${unitYears}`);
        $('#eos-strat-a-interest-val').text(formatMoney(res.interestSavedA));
        $('#eos-strat-a-capital-val').text(formatMoney(res.capitalAtFinishA));

        // Strategy B Card
        $('#eos-strat-b-capital-val').text(formatMoney(res.portfolioB));
        $('#eos-strat-b-coupons-val').text(formatMoney(res.finalMonthlyCoupon));
        $('#eos-strat-b-edge-val').text(formatMoney(res.netArbitrageAdvantage));

        // Detailed Timeline Table
        const $tbody = $('#eos-timeline-tbody');
        $tbody.empty();

        res.timeline.forEach(row => {
            const tr = `
                <tr>
                    <td class="fw-bold text-body">${tableYearCellFormat.replace('{0}', row.year)}</td>
                    <td class="text-danger fw-semibold text-end">${formatMoney(row.loanBalance)}</td>
                    <td class="text-success fw-bold text-end">${formatMoney(row.bondPortfolio)}</td>
                    <td class="text-body fw-semibold text-end">${formatMoney(row.annualCoupons)}</td>
                    <td class="text-end">
                        <span class="badge ${row.coverageRatio >= 100 ? 'bg-success text-white' : 'bg-light text-body border'} font-size-11">
                            ${row.coverageRatio.toFixed(0)}%
                        </span>
                    </td>
                </tr>
            `;
            $tbody.append(tr);
        });

        // Sync inputs
        $('#eos-loan-amount-input').val(state.loanAmount);
        $('#eos-loan-amount-range').val(state.loanAmount);
        $('#eos-loan-term-input').val(state.loanTermYears);
        $('#eos-loan-term-range').val(state.loanTermYears);
        $('#eos-extra-input').val(state.extraPayment);
        $('#eos-extra-range').val(state.extraPayment);
        $('#eos-rate-input').val(state.mortgageRate);
        $('#eos-bonds-input').val(state.bondsYield);
    }

    // Event Listeners
    // 1. Sliders & Inputs Sync
    $('#eos-loan-amount-input').on('input change', function () {
        state.loanAmount = parseFloat($(this).val()) || 0;
        $('#eos-loan-amount-range').val(state.loanAmount);
        render();
    });
    $('#eos-loan-amount-range').on('input', function () {
        state.loanAmount = parseFloat($(this).val()) || 0;
        $('#eos-loan-amount-input').val(state.loanAmount);
        render();
    });

    $('#eos-loan-term-input').on('input change', function () {
        state.loanTermYears = parseInt($(this).val(), 10) || 1;
        $('#eos-loan-term-range').val(state.loanTermYears);
        render();
    });
    $('#eos-loan-term-range').on('input', function () {
        state.loanTermYears = parseInt($(this).val(), 10) || 1;
        $('#eos-loan-term-input').val(state.loanTermYears);
        render();
    });

    $('#eos-extra-input').on('input change', function () {
        state.extraPayment = parseFloat($(this).val()) || 0;
        $('#eos-extra-range').val(state.extraPayment);
        render();
    });
    $('#eos-extra-range').on('input', function () {
        state.extraPayment = parseFloat($(this).val()) || 0;
        $('#eos-extra-input').val(state.extraPayment);
        render();
    });

    $('#eos-rate-input').on('input change', function () {
        state.mortgageRate = parseFloat($(this).val()) || 0;
        render();
    });

    $('#eos-bonds-input').on('input change', function () {
        state.bondsYield = parseFloat($(this).val()) || 0;
        render();
    });

    // 2. Rate Shortcut Buttons
    $('button[data-eos-rate]').on('click', function () {
        const r = parseFloat($(this).data('eos-rate'));
        state.mortgageRate = r;
        $('#eos-rate-input').val(r);
        $('button[data-eos-rate]').removeClass('active btn-primary').addClass('btn-light');
        $(this).addClass('active btn-primary').removeClass('btn-light');
        render();
    });

    function updateCurrencyUI() {
        const cfg = currencyConfigs[activeCurrency];
        $('.eos-currency-symbol').text(cfg.symbol);

        $('#eos-loan-amount-range')
            .attr('min', cfg.loanMin)
            .attr('max', cfg.loanMax)
            .attr('step', cfg.loanStep);

        $('#eos-loan-amount-input')
            .attr('min', cfg.loanMin / 2)
            .attr('max', cfg.loanMax * 2)
            .attr('step', cfg.loanStep);

        $('#eos-extra-range')
            .attr('min', cfg.extraMin)
            .attr('max', cfg.extraMax)
            .attr('step', cfg.extraStep);

        $('#eos-extra-input')
            .attr('min', cfg.extraMin / 2)
            .attr('max', cfg.extraMax * 2)
            .attr('step', cfg.extraStep);

        const currentPreset = getPresetForCurrency(activePreset, activeCurrency);
        state.loanAmount = currentPreset.loanAmount;
        state.extraPayment = currentPreset.extraPayment;

        render();
    }

    // 3. Presets
    $('button[data-eos-preset]').on('click', function () {
        const pKey = $(this).data('eos-preset');
        activePreset = pKey;
        const p = getPresetForCurrency(pKey, activeCurrency);

        $('button[data-eos-preset]').removeClass('active btn-primary').addClass('btn-light');
        $(`button[data-eos-preset="${pKey}"]`).addClass('active btn-primary').removeClass('btn-light');

        state.loanAmount = p.loanAmount;
        state.loanTermYears = p.loanTermYears;
        state.mortgageRate = p.mortgageRate;
        state.extraPayment = p.extraPayment;
        state.bondsYield = p.bondsYield;

        // Update rate shortcut button styles
        $('button[data-eos-rate]').removeClass('active btn-primary').addClass('btn-light');
        $(`button[data-eos-rate="${p.mortgageRate}"]`).addClass('active btn-primary').removeClass('btn-light');

        render();
    });

    // 4. Currency selection (Direct tabs)
    $(document).on('click', '#eos-currency-tabs > button[data-currency]', function () {
        $('#eos-currency-tabs button').removeClass('active');
        $(this).addClass('active');
        $('.eos-more-currencies-btn').removeClass('active');
        $('.eos-currency-dropdown-item').removeClass('active');
        $('#eos-active-custom-currency').html(`
            <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
            <span class="d-sm-none">${textMoreShort}</span>
        `);

        activeCurrency = $(this).data('currency');
        updateCurrencyUI();
    });

    // 5. Currency selection (Dropdown items)
    $(document).on('click', '.eos-currency-dropdown-item', function (e) {
        e.preventDefault();
        const selCurr = $(this).data('currency');
        const selSymbol = $(this).data('symbol') || '$';

        $('#eos-currency-tabs > button[data-currency]').removeClass('active');
        $('.eos-currency-dropdown-item').removeClass('active');
        $(this).addClass('active');

        $('.eos-more-currencies-btn').addClass('active');
        $('#eos-active-custom-currency').text(`${selSymbol} ${selCurr}`);

        activeCurrency = selCurr;
        updateCurrencyUI();
    });

    // Initial render
    updateCurrencyUI();
});

